import CallCenterAgentLogs from "./CallCenterAgentLogs";

const CallCenterAgentLogsConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/callcenter/agent/logs',
			component: CallCenterAgentLogs
		}
	]
};

export default CallCenterAgentLogsConfig;
